import React, { useContext, useState, useEffect } from 'react';
import { Pagination, Spin } from 'antd';

import api from '../../api';
import SideBar from '../../components/common/sidebar';

import './sales-goals.css';
import { PiTarget } from "react-icons/pi";
import { Context } from '../../context/AuthContext';

import Filter from './filter';
import EditSalesGoal from './editSalesGoal';
import AddSalesGoal from './addSalesGoal';
import List from './list';

function SalesGoals() {
    const { userData } = useContext(Context);

    const [users, setUsers] = useState([])
    const [wallets, setWallets] = useState([])
    const [salesGoals, setSalesGoals] = useState([])
    const [salesGoal, setSalesGoal] = useState({})
    const [loadSalesGoals, setLoadSalesGoals] = useState(true)
    const [totalSalesGoals, setTotalSalesGoals] = useState(0);
    const [modalSalesGoal, setModalSalesGoal] = useState(false);
    const [page, setPage] = useState(1)

    // Filters
    const [filters, setFilters] = useState({})

    // Summary
    const [summary, setSummary] = useState({ total: 0, annualGoal: 0, remaining: 0, monthlyGoal: 0, monthlyRemaining: 0 })

    useEffect(() => {
        (async () => {
            const { data } = await api.get('/users/call-center');
            setUsers(data)
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const { data } = await api.get('/wallets');
            setWallets(data)
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const { data } = await api.get('/sales-goals');
            setSalesGoals(data.salesGoals);
            setTotalSalesGoals(data.total);
            setLoadSalesGoals(false)
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const currentYear = new Date().getFullYear();
            let url = `/sales-goals/summary/${currentYear}`;
            const params = [];
            if (filters.month && filters.month.length > 0) {
                const monthParam = Array.isArray(filters.month) ? filters.month.join(',') : filters.month;
                params.push(`month=${monthParam}`);
            }
            if (filters.responsible && filters.responsible.length > 0) {
                const responsibleParam = Array.isArray(filters.responsible) ? filters.responsible.join(',') : filters.responsible;
                params.push(`responsible=${responsibleParam}`);
            }
            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }
            const { data } = await api.get(url);
            setSummary(data)
        })();
    }, [salesGoals, filters]);

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Anterior</a>;
        }
        if (type === 'next') {
            return <a>Próxima</a>;
        }
        return originalElement;
    }

    function selectSalesGoal(id) {
        let sg = salesGoals.filter((item) => {
            return item._id == id
        })[0]
        setSalesGoal(sg)
        setModalSalesGoal(true)
    }

    async function changePage(page) {
        setLoadSalesGoals(true)

        let url = `/sales-goals?page=${page}`

        if (filters.month && filters.month.length > 0) {
            const monthParam = Array.isArray(filters.month) ? filters.month.join(',') : filters.month;
            url = url.concat(`&month=${monthParam}`)
        }

        if (filters.operator)
            url = url.concat(`&operator=${filters.operator}`)

        if (filters.responsible && filters.responsible.length > 0) {
            const responsibleParam = Array.isArray(filters.responsible) ? filters.responsible.join(',') : filters.responsible;
            url = url.concat(`&responsible=${responsibleParam}`)
        }

        if (filters.search)
            url = url.concat(`&search=${filters.search}`)

        const { data } = await api.get(url);
        setSalesGoals(data.salesGoals);
        setPage(page)
        setLoadSalesGoals(false)
    }

    return (
        <div className="page-content">
            <SideBar page="sales-goals" title="Metas de Vendas" icon={<PiTarget size="2em" />} />
            <div className="content">

                <div className="sales-goals-container">

                    <Filter
                        setLoadSalesGoals={setLoadSalesGoals}
                        setTotalSalesGoals={setTotalSalesGoals}
                        salesGoals={salesGoals}
                        setSalesGoals={setSalesGoals}
                        filters={filters}
                        setFilters={setFilters}
                        users={users}
                        wallets={wallets}
                        summary={summary}
                        setSummary={setSummary}
                    />

                    {loadSalesGoals
                        ? <Spin tip="Carregando metas de vendas..."><div className="loading-sales-goals"></div></Spin>
                        : <div className="sales-goals-list">
                            {(userData.roles.includes('admin') || userData.roles.includes('supervisor')) &&
                                <AddSalesGoal
                                    salesGoals={salesGoals}
                                    setSalesGoals={setSalesGoals}
                                    wallets={wallets}
                                    users={users}
                                />
                            }
                            <List salesGoals={salesGoals} selectSalesGoal={selectSalesGoal} />
                        </div>
                    }

                    {salesGoals.length > 0 &&
                        <div className="sales-goals-pagination">
                            <Pagination
                                onChange={(e) => changePage(e)}
                                total={totalSalesGoals}
                                itemRender={itemRender}
                                current={page}
                                showSizeChanger={false}
                            />
                        </div>
                    }
                </div>

                {salesGoal &&
                    <EditSalesGoal
                        salesGoal={salesGoal}
                        setSalesGoal={setSalesGoal}
                        setSalesGoals={setSalesGoals}
                        modalSalesGoal={modalSalesGoal}
                        setModalSalesGoal={setModalSalesGoal}
                        page={page}
                        filters={filters}
                        wallets={wallets}
                        users={users}
                    />
                }
            </div>
        </div>
    )

}

export default SalesGoals;
